// src/icons/SendInviteIcon.js
// Source is Tabler (send icon)
import React from 'react';

export default function SendInviteIcon({ size = 24, color = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      style={{ display: 'block' }}
      {...props}
    >
      <path d="M22 2L11 13" />
      <path d="M22 2L14 22L10 13L2 9L22 2Z" />
    </svg>
  );
}
